<mat-dialog-content class="koordinaten-hilfe-bild">
  <img
    src="assets/img/Abbildung-4.jpg"
    alt="Darstellung des Koordinatensystems für die Positionierung der Quelle"
  />
</mat-dialog-content>
